const organization_details = {
    departments: {
        leader: 'مسئول',
        leaders: 'مسئولان بخش',
        led_departments: 'بخش‌های تحت مدیریت',
        edit_leaders: 'مدیریت مسئولان',
        add_leader: 'افزودن',
        remove_leader: 'حذف',
        no_leaders: 'مسئولی تعیین نشده',
        local: 'مدیریت محلی',
        managed_members: 'اعضای محدوده مدیریت',
        leader_scope_hint: 'عضویت بخش‌های خود و زیربخش‌ها را مدیریت کنید.',
        leader_permission_hint: 'مسئولان عضویت بخش‌های خود و زیربخش‌ها را مدیریت می‌کنند و نقش‌ها یا ساختار سازمان را تغییر نمی‌دهند.',
        primary_synced: 'بخش اصلی توسط Feishu مدیریت می‌شود.',
        status_active: 'فعال',
        status_suspended: 'تعلیق‌شده',
        status_departed: 'خارج‌شده',
        status_pending: 'در انتظار فعال‌سازی',
        search: 'جستجو',
        previous_page: 'صفحه قبلی',
        next_page: 'صفحه بعدی',
        directory_title: 'اعضای سازمان',
        member_name: 'عضو',
        search_members: 'جستجو بر اساس نام یا نام کاربری',
        include_descendants: 'شامل بخش‌های فرعی',
        no_members: 'عضو منطبقی یافت نشد.',
        all_members: 'همه اعضا',
        all_departments: 'همه بخش‌ها',
        edit_member: 'ویرایش بخش‌ها',
        add_child: 'افزودن بخش فرعی',
        expand_department: 'باز کردن {{name}}',
        collapse_department: 'بستن {{name}}',
        title: 'بخش‌ها',
        description: 'بخش‌ها و عضویت اعضا را در این سازمان مدیریت کنید.',
        create: 'ایجاد بخش',
        edit: 'ویرایش بخش',
        name: 'نام بخش',
        parent: 'بخش بالادست',
        root: 'بدون بخش بالادست',
        id: 'شناسه بخش',
        members: 'بخش‌های اعضا',
        member_id: 'شناسه کاربری عضو',
        primary: 'بخش اصلی',
        none: 'تنظیم نشده',
        assignments: 'عضویت بخش‌ها',
        no_assignments: 'هنوز عضویتی در بخش‌ها وجود ندارد.',
        assignment_hint: 'بخش‌های محلی و در صورت نیاز یک بخش اصلی تعیین کنید. عضویت‌های فهرست فقط خواندنی هستند.',
        empty: 'هنوز بخشی وجود ندارد.',
        readonly: 'می‌توانید بخش‌ها و عضویت خود را ببینید. برای تغییر با مدیر سازمان تماس بگیرید.',
        load_error: 'بارگیری داده‌ها ناموفق بود. دوباره تلاش کنید.',
        mutation_error: 'ذخیره نشد. مجوزها، عضویت و سلسله‌مراتب بخش‌ها را بررسی کنید.',
        loading: 'در حال بارگیری…',
        synced: 'مدیریت‌شده توسط فهرست',
        choose: 'جستجوی بخش‌ها',
        organizations_title: 'سازمان‌ها و بخش‌ها',
        organizations_description: 'برای مشاهده یا مدیریت بخش‌ها، سازمانی انتخاب کنید.',
        no_organizations: 'عضو هیچ سازمانی نیستید. با مدیر سازمان تماس بگیرید.',
        organization: 'سازمان فعلی',
        choose_organization: 'انتخاب سازمان',
        delete_title: 'حذف بخش',
        delete_description: '«{{name}}» حذف شود؟ ابتدا اعضا و زیربخش‌ها را منتقل کنید.',
    },
    directory: {
        leaders_label: 'مسئولیت بخش‌ها',
        local_department_leader: 'مسئول بخش تعیین‌شده محلی',
        status_active: 'فعال',
        status_suspended: 'تعلیق‌شده',
        status_departed: 'خارج‌شده',
        status_pending: 'در انتظار فعال‌سازی',
        profiles_label: 'نمایه‌های مبدأ',
        primary_label: 'تغییرات بخش اصلی',
        deactivated_label: 'هویت‌های غیرفعال',
        reactivated_label: 'هویت‌های فعال‌شده مجدد',
        lifecycle_notice: 'تخصیص‌های نقش حفظ‌شده: {{count}}. فعال‌سازی مجدد دسترسی‌های قبلی را بازمی‌گرداند.',
        title: 'فهرست Feishu',
        description: 'بخش‌ها و اعضا را با اتصال‌دهنده Feishu به این سازمان وارد کنید.',
        identity_notice: 'از اتصال‌دهنده با تأمین فهرست فعال استفاده کنید. تغییر هویت اتصال‌دهنده موجود نیازمند مهاجرت حساب‌هاست.',
        connector: 'شناسه اتصال‌دهنده Feishu',
        preview: 'پیش‌نمایش همگام‌سازی',
        preview_title: 'پیش‌نمایش همگام‌سازی',
        preview_description: 'پیش از واردکردن، فهرست را بررسی کنید. اگر تغییر کرد دوباره پیش‌نمایش بگیرید.',
        import: 'تأیید همگام‌سازی',
        success: '{{departments}} بخش و {{users}} عضو وارد و {{createdUsers}} حساب ایجاد شد. {{removedDepartments}} بخش، {{removedMemberships}} عضویت و {{removedAssignments}} انتساب حذف شد.',
        failure: 'خواندن یا واردکردن فهرست ناموفق بود. مجوزها و محدوده دید اتصال‌دهنده را بررسی و دوباره پیش‌نمایش بگیرید.',
        behavior_title: 'روش واردکردن',
        mode: 'نام، تصویر، بخش‌ها و بخش اصلی همگام می‌شوند. اعضای غایب یا غیرفعال فقط دسترسی این سازمان را از دست می‌دهند؛ نقش‌ها، تخصیص‌های محلی، حساب‌های سراسری و هویت سایر سازمان‌ها حفظ می‌شوند. ایمیل و تلفن صرفاً اطلاعات مبدأ هستند و به اطلاعات ورود تبدیل نمی‌شوند.',
        limits: 'هر بار: 1000 بخش، 5000 کاربر، 10000 عضویت؛ مهلت خواندن 60 ثانیه. داده ناقص یا بیش از حد رد می‌شود.',
        counts: '{{departments}} بخش · {{users}} عضو',
        departments_label: 'بخش‌ها',
        members_label: 'عضویت‌های سازمانی',
        assignments_label: 'انتساب‌های بخش',
        item: 'مورد',
        added: 'افزودن',
        updated: 'به‌روزرسانی',
        removed: 'حذف',
        cleanup_notice: 'نام، تصویر، بخش‌ها و بخش اصلی همگام می‌شوند. اعضای غایب یا غیرفعال فقط دسترسی این سازمان را از دست می‌دهند؛ نقش‌ها، تخصیص‌های محلی، حساب‌های سراسری و هویت سایر سازمان‌ها حفظ می‌شوند. ایمیل و تلفن صرفاً اطلاعات مبدأ هستند و به اطلاعات ورود تبدیل نمی‌شوند.',
        conflicts_title: '{{count}} تعارض مانع همگام‌سازی است. وابستگی‌های محلی را رفع و دوباره پیش‌نمایش کنید.',
        removals_title: 'نمونه موارد حذف (حداکثر ۲۰ مورد در هر دسته)',
        local_child_department: 'زیربخش محلی',
        unowned_assignment: 'انتساب محلی یا قدیمی بدون منبع تأییدشده',
        local_member_roles: 'عضو دارای نقش‌های محلی است',
        unlinked_identity: 'پیوند هویت فهرست قطع شده است',
    },
    page_title: 'جزئیات سازمان',
    delete_confirmation: 'پس از حذف، همه اعضا عضویت و نقش‌های خود در این سازمان را از دست می‌دهند. این عمل قابل بازگشت نیست.',
    organization_id: 'شناسه سازمان',
    settings_description: 'سازمان‌ها نمایانگر تیم‌ها، مشتریان تجاری و شرکت‌های شریک هستند که می‌توانند به برنامه‌های شما دسترسی داشته باشند.',
    name_placeholder: 'نام سازمان، نیازی به یکتا بودن ندارد.',
    description_placeholder: 'توضیح سازمان.',
    member: 'عضو',
    member_other: 'اعضا',
    add_members_to_organization: 'افزودن اعضا به سازمان {{name}}',
    add_members_to_organization_description: 'کاربران مناسب را با جستجوی نام، ایمیل، تلفن یا شناسه کاربر پیدا کنید. اعضای موجود در نتایج جستجو نمایش داده نمی‌شوند.',
    add_with_organization_role: 'افزودن با نقش(های) سازمان',
    user: 'کاربر',
    application: 'برنامه',
    application_other: 'برنامه‌ها',
    add_applications_to_organization: 'افزودن برنامه‌ها به سازمان {{name}}',
    add_applications_to_organization_description: 'برنامه‌های مناسب را با جستجوی شناسه برنامه، نام یا توضیحات پیدا کنید. برنامه‌های موجود در نتایج جستجو نمایش داده نمی‌شوند.',
    at_least_one_application: 'حداقل یک برنامه لازم است.',
    remove_application_from_organization: 'حذف برنامه از سازمان',
    remove_application_from_organization_description: 'پس از حذف، برنامه ارتباط و نقش‌های خود در این سازمان را از دست می‌دهد. این عمل قابل بازگشت نیست.',
    search_application_placeholder: 'جستجو بر اساس شناسه برنامه، نام یا توضیحات',
    roles: 'نقش‌های سازمان',
    authorize_to_roles: '{{name}} را مجاز کنید به نقش‌های زیر دسترسی داشته باشد:',
    edit_organization_roles: 'ویرایش نقش‌های سازمان',
    edit_organization_roles_title: 'ویرایش نقش‌های سازمان {{name}}',
    remove_user_from_organization: 'حذف کاربر از سازمان',
    remove_user_from_organization_description: 'پس از حذف، کاربر عضویت و نقش‌های خود در این سازمان را از دست می‌دهد. این عمل قابل بازگشت نیست.',
    search_user_placeholder: 'جستجو بر اساس نام، ایمیل، تلفن یا شناسه کاربر',
    at_least_one_user: 'حداقل یک کاربر لازم است.',
    organization_roles_tooltip: 'نقش‌های اختصاص‌یافته به {{type}} در این سازمان.',
    custom_data: 'داده سفارشی',
    custom_data_tip: 'داده سفارشی یک شیء JSON است که می‌تواند برای ذخیره داده‌های اضافی مرتبط با سازمان استفاده شود.',
    invalid_json_object: 'شیء JSON نامعتبر است.',
    branding: {
        name: 'برندسازی',
        description: 'تجربه ورود در سطح سازمان را سفارشی کنید.',
        organization_level_sie: 'تجربه ورود در سطح سازمان',
        organization_level_sie_switch: 'تجربه ورود در سطح سازمان را فعال کنید و برندسازی مختص سازمان را تنظیم کنید. اگر غیرفعال باشد، ابتدا به تجربه ورود در سطح برنامه و سپس به تجربه ورود جامع بازمی‌گردد.',
        logo: 'لوگوهای سازمان',
        logo_tooltip: 'می‌توانید شناسه سازمان را ارسال کنید تا این لوگو در تجربه ورود نمایش داده شود؛ نسخه تاریک لوگو در صورت فعال بودن حالت تاریک در تنظیمات تجربه ورود جامع لازم است. <a>بیشتر بدانید</a>',
    },
    jit: {
        title: 'تأمین لحظه‌ای',
        description: 'کاربران می‌توانند به‌صورت خودکار به سازمان بپیوندند و نقش‌ها را در اولین ورود از طریق برخی روش‌های احراز هویت دریافت کنند. می‌توانید الزامات تأمین لحظه‌ای را تنظیم کنید.',
        email_domain: 'تأمین بر اساس دامنه ایمیل',
        email_domain_description: 'کاربران جدیدی که با آدرس ایمیل تأییدشده ثبت‌نام می‌کنند یا از طریق ورود اجتماعی با ایمیل تأییدشده وارد می‌شوند، به‌صورت خودکار به سازمان می‌پیوندند. <a>بیشتر بدانید</a>',
        email_domain_placeholder: 'دامنه‌های ایمیل را برای تأمین لحظه‌ای وارد کنید',
        invalid_domain: 'دامنه نامعتبر',
        domain_already_added: 'دامنه از قبل اضافه شده است',
        sso_enabled_domain_warning: 'یک یا چند دامنه ایمیل مرتبط با SSO سازمانی وارد کرده‌اید. کاربران با این ایمیل‌ها جریان استاندارد SSO را دنبال می‌کنند و تا زمانی که تأمین SSO سازمانی پیکربندی نشود، به این سازمان تأمین نمی‌شوند.',
        enterprise_sso: 'تأمین SSO سازمانی',
        no_enterprise_connector_set: 'هنوز هیچ اتصال‌دهنده SSO سازمانی راه‌اندازی نکرده‌اید. ابتدا اتصال‌دهنده‌ها را اضافه کنید تا تأمین SSO سازمانی فعال شود. <a>راه‌اندازی</a>',
        add_enterprise_connector: 'افزودن اتصال‌دهنده سازمانی',
        enterprise_sso_description: 'کاربران جدید یا موجود که برای اولین بار از طریق SSO سازمانی وارد می‌شوند، به‌صورت خودکار به سازمان می‌پیوندند. <a>بیشتر بدانید</a>',
        organization_roles: 'نقش‌های پیش‌فرض سازمان',
        organization_roles_description: 'نقش‌ها را هنگام پیوستن کاربران به سازمان از طریق تأمین لحظه‌ای اختصاص دهید.',
    },
    mfa: {
        title: 'احراز هویت چندعاملی (MFA)',
        tip: 'وقتی MFA الزامی است، کاربران بدون MFA پیکربندی‌شده هنگام تلاش برای تبادل توکن سازمان رد می‌شوند. این تنظیم بر احراز هویت کاربر تأثیر نمی‌گذارد.',
        description: 'از کاربران بخواهید احراز هویت چندعاملی را برای دسترسی به این سازمان پیکربندی کنند.',
        no_mfa_warning: 'هیچ روش احراز هویت چندعاملی برای مستأجر شما فعال نیست. کاربران تا زمانی که حداقل یک <a>روش احراز هویت چندعاملی</a> فعال شود، نمی‌توانند به این سازمان دسترسی داشته باشند.',
    },
};
export default Object.freeze(organization_details);
